<template>
    <GenericTable 
        :Variant="Variant" 
        :Headers="headers"
        :Rows="Certificate.MeterInformations.Meters"
        :EnableSelection="false"
        :EnablePagination="true"
        :PerPage="13"
        :ShowDeleteButton="false"
        :ShowModifyButton="false"
        :ShowSearchField="true">
        <template #toolbar-right>
            <slot name="toolbar-right"></slot>
        </template>
        <!-- COLONNE D'AFFICHAGE DES NOMS -->
        <template #column(Name)="row">
            {{ row.row.Informations.MeterName }}
        </template>
        <!-- COLONNE D'AFFICHAGE DES ADRESSES -->
        <template #column(Address)="row">
            {{ row.row.Informations.Address }}
        </template>
        <!-- COLONNE D'AFFICHAGE DES ENERGIES DU COMPTEUR -->
        <template #column(Expendables)="row">
            <ExpendableCell 
                :Values="row.row.Informations.Expendables"/>
        </template>
        <!-- COLONNE D'AFFICHAGE DES SERVICES DU COMPTEUR -->
        <template #column(Services)="row">
            <ServicesCell 
                :Id="row.row.Informations.PersistentRef" 
                :Services="row.row.Services"/>
        </template>
        <!-- COLONNE D'AFFICHAGE DES ERREURS DU COMPTEUR -->
        <template #column(Errors)="row">
            <ErrorsCell 
                :Id="row.row.Informations.PersistentRef" 
                :Values="row.row.Errors"/>
        </template>
        <template #column(Status)="row">
            <!-- BOUTON POUR RECUPERER LES DONNEES SUR LE COMPTEUR -->
            <b-button 
                @click="RefreshEvent(row.row.Informations.PersistentRef)" 
                :variant="IsRefreshAvailable() ? 'outline-' + Variant : 'danger'" 
                pill
                :disabled="IsRefreshAvailable()"
                v-b-tooltip.hover 
                :title="$t('RefreshEvent')"
                size="sm">
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" />
            </b-button>
        </template>
    </GenericTable> 
</template>
<script lang="ts">

    /**
     * Composants Vue js
     */
    import { Vue, Component, Prop, InjectReactive } from 'vue-property-decorator';

    /**
     * Traductions
     */
    import locale from '../../locales/SMA.json';

    /**
     * Classes tableau générique
     */
    import GenericTable, { CssClass, HeaderCustom, HeaderString, IHeader, SelectionTypeEnum } from '@/components/commons/Generics/GenericTable.vue';

    /**
     * Cellules custom pour l'affichage des compteurs
     */
    import ExpendableCell from '../CustomsCells/ExpendableCell.vue';
    import ErrorsCell from '../CustomsCells/ErrorsCell.vue';
    import ServicesCell from '../CustomsCells/ServiceCell.vue';
    import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';
    import CertificateStateEnum from '@/enums/Administration/SMA/CertificateStateEnum';

	@Component({
		components: {
            GenericTable,
            ExpendableCell,
            ErrorsCell,
            ServicesCell
        },
        i18n:{messages:locale}
	})
    /**
     * Composant d'affichage de la liste des compteurs
     */
	export default class MetersList extends Vue {
        
        /**
         * Liste de mandats
         */
        @Prop()
        public Certificate!: SMACertificate;

        /** 
         * Variant de couleur à appliquer sur le composant 
         */
        @InjectReactive()
        public Variant!: string;

        /**
         * Mode d'utilisation
         */
        @Prop()
        private Mode!: "Display" | "Edit";

        /**
         * En-têtes tableau générique
         */
        private headers:  IHeader[] = [
            new HeaderCustom('Name', this.$t('Name').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderString('RaepceNumber', this.$t('RAEPCENumber').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Address', this.$t('Address').toString(), {Sort: false, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Expendables', this.$t('Expendables').toString(), {Sort: false, CssClasses : [new CssClass({CssClass: 'text-center'})], Tooltip: this.$t('ExpendablesTooltip').toString()}),
            new HeaderCustom('Services', this.$t('Services').toString(), {Sort: false, ShowLabel: false, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Errors', this.$t('Errors').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderCustom('Status', this.$t('Status').toString(), {Sort: false, ShowLabel: false, CssClasses : [new CssClass({CssClass: 'text-center'})]})
        ]
        
        /**
         * Enumération pour le tableau générique
         */
        private selectionTypeEnum = SelectionTypeEnum;

        /**
         * Emission event de rafraichissement de compteur
         * @param Id Identifiant du compteur
         */
        private RefreshEvent(id: string) :void
        {
            this.$emit('RefreshEvent', id);
        }

        /**
         * Indique si le bouton refresh est utilisable ou non
         */
        private IsRefreshAvailable() {
            return this.Certificate.Status == CertificateStateEnum.SupervisorValidated || this.Certificate.Status == CertificateStateEnum.None
        }

        /** 
         * DESACTIVE POUR LE MOMENT
         * A REACTIVER QUAND ON EN AURA BESOIN ET QUE L'INTERFACE SERA EN PLACE ET CONFORME AUX BESOINS
         */
    
        /**
         * Renouvellement de l'abonnement du compteur
         * @param Id Identifiant du compteur
         */
        private RenewSubscribtionEvent(id: string) :void
        {
            this.$emit('RenewSubscribtionEvent', id);
        }
    }
    
</script>
<style scoped>
</style>